import React, { useState } from 'react';

const DeliveryTypeModal = ({ order, onClose, onSubmit }) => {
    const [deliveryType, setDeliveryType] = useState(order?.deliveryType || 'scheduled');
    const [windowStart, setWindowStart] = useState('');
    const [windowEnd, setWindowEnd] = useState('');

    const handleConfirm = () => {
        if (deliveryType === 'scheduled') {
            if (!windowStart || !windowEnd) {
                alert('Please select both slot start and end time.');
                return;
            }
            onSubmit({ deliveryType, deliveryWindowStart: windowStart, deliveryWindowEnd: windowEnd });
        } else {
            onSubmit({ deliveryType });
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-50 overflow-y-auto h-full w-full flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
                <div className="px-6 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
                    <h3 className="text-lg font-bold text-gray-800">Set Delivery Type</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-red-500 transition-colors outline-none rounded-full p-1 hover:bg-red-50">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                </div>

                <div className="p-6 space-y-5">
                    <p className="text-sm text-gray-600">Order <span className="font-semibold text-gray-900">#{order?.orderNumber}</span></p>

                    <div className="flex gap-3">
                        <button
                            type="button"
                            onClick={() => setDeliveryType('instant')}
                            className={`flex-1 px-4 py-3 rounded-xl font-semibold text-sm border-2 transition-colors ${deliveryType === 'instant' ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                        >
                            ⚡ Instant (15 mins)
                        </button>
                        <button
                            type="button"
                            onClick={() => setDeliveryType('scheduled')}
                            className={`flex-1 px-4 py-3 rounded-xl font-semibold text-sm border-2 transition-colors ${deliveryType === 'scheduled' ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                        >
                            🕒 Scheduled Slot
                        </button>
                    </div>

                    {deliveryType === 'scheduled' && (
                        <div className="space-y-3">
                            <div>
                                <label className="text-sm font-semibold text-gray-700">Slot Start</label>
                                <input
                                    type="datetime-local"
                                    value={windowStart}
                                    onChange={(e) => setWindowStart(e.target.value)}
                                    className="w-full mt-1 p-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                                />
                            </div>
                            <div>
                                <label className="text-sm font-semibold text-gray-700">Slot End</label>
                                <input
                                    type="datetime-local"
                                    value={windowEnd}
                                    onChange={(e) => setWindowEnd(e.target.value)}
                                    className="w-full mt-1 p-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">
                    <button onClick={onClose} className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-red-500 hover:bg-red-600 shadow-sm transition-colors">
                        Cancel
                    </button>
                    <button onClick={handleConfirm} className="px-5 py-2.5 rounded-xl font-bold text-sm text-white bg-green-600 hover:bg-green-700 shadow-md transition-colors">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeliveryTypeModal;
